import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { DocumentAccessHeaderArea } from "./documentAccessHeaderArea";
import { DocumentAccessMainArea } from "./documentAccessMainArea";
import { DocumentAccessContentType } from "./models/DocumentAccessContentType";
import { DocumentAccessRightsService } from "../../services/documentAccessRightsService";
import { BaseDocumentAccessRightData } from "./models/BaseDocumentAccessRightData";
import { FarOnlineAddon } from "./models/FarOnlineAddon";
import { MissingPackageOrExtensionData } from "./models/MissingPackageOrExtensionData";
import { ScrollLock } from "../../modules/helpers/scrollLock";
import { useDebouncedCallback } from 'use-debounce';
import { BlurredModalOverlay } from "../../components/BlurredModalOverlay/blurredModalOverlay";

export const DocumentAccessRightsModal = () => {
  const [modalIsOpen, setModalIsOpen] = useState(true);
  const [contentType, setContentType] = useState<number>(
    DocumentAccessContentType.NotFetched
  );
  const [documentAccessData, setDocumentAccessData] =
    useState<BaseDocumentAccessRightData>();
  const [farOnlinePackageOrAddons, setFarOnlinePackageOrAddons] =
    useState<FarOnlineAddon[]>();
  const [pageId, setPageId] = useState<string>("");
  const [returnUrl, setReturnUrl] = useState<string>("");
  const [showOnlyPackages, setShowOnlyPackages] = useState<boolean>(false);
  const [addonCheckoutUrl, setAddonCheckoutUrl] = useState<string>("");
  const [width, setWidth] = useState<number>(400);
  const [leftLocation, setLeftLocation] = useState<number>(450);

  const documentAccessRightsService = new DocumentAccessRightsService();

  useEffect(() => {
    setContentType(
      parseInt(
        (document.getElementById("document-access-type") as HTMLInputElement)
          ?.value
      )
    );
    setReturnUrl(
      (document.getElementById("document-return-url") as HTMLInputElement)
        ?.value
    );
    const pageId = (
      document.getElementById("document-page-id") as HTMLInputElement
    )?.value;
    if (pageId) setPageId(pageId);
  }, []);

    useEffect(() => {
        const handler = (e) => {
            if (e.key !== 'Tab') return;

            const modal = document.querySelector('.ReactModal__Content');
            const active = document.activeElement;

            if (!modal || !modal.contains(active)) return;

            const focusables = [...modal.querySelectorAll(
                'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
            )];

            const first = focusables[0];
            const last = focusables[focusables.length - 1];
            const headerLogo = document.querySelector('.header__logo');

            if (!e.shiftKey && active === last) {
                e.preventDefault();
                headerLogo?.focus();
                return;
            }

            // 👉 SHIFT + TAB (första elementet)
            if (e.shiftKey && active === first) {
                e.preventDefault();
                headerLogo?.focus();
                return;
            }
        };

        document.addEventListener('keydown', handler, true);
        return () => document.removeEventListener('keydown', handler, true);
    }, []);

  const hideModal = () => {
    setModalIsOpen(false);
  };

  const getWidthOfDocument = useDebouncedCallback(() => {
      if (window) {
        let checkContainer = "documentcontent-main";

        let onEOBpage = document.getElementById('eob-search');
        if (onEOBpage) {
            checkContainer = "productlist";
        }

        const w = document.getElementById(checkContainer)?.offsetWidth;
        const rect = document.getElementById(checkContainer)?.getBoundingClientRect();

        if (!!w && w > 0) {
            setWidth(w);
        }
        if (!!w && w>1400) {
            if (rect?.left) {
                setLeftLocation(rect.left + (rect.left/2));
            }
        } else {
            if (!!rect?.left) {
                setLeftLocation(rect?.left)
            }
        }
    }
  }, 20);

  useEffect(() => {
    getWidthOfDocument();
    window.addEventListener('resize', getWidthOfDocument);
  },[]);

  useEffect(() => {
    switch (contentType) {
      case DocumentAccessContentType.NotLoggedIn: {
        documentAccessRightsService.getNotLoggedInData(
          (response: BaseDocumentAccessRightData) =>
            setDocumentAccessData(response),
          () => {}
        );
        break;
      }
      case DocumentAccessContentType.MissingPackageOrExtension: {
        documentAccessRightsService.getMissingPackageOrExtensionData(
          pageId,
          showOnlyPackages,
          (response: MissingPackageOrExtensionData) => {
            setDocumentAccessData(response);
            setAddonCheckoutUrl(response.addonCheckoutUrl);
            setFarOnlinePackageOrAddons(response.packagesAndAddons);
            setShowOnlyPackages(response.showOnlyPackages);
          },
          () => {}
        );
        break;
      }
      case DocumentAccessContentType.ExpiredTestPeriod: {
        documentAccessRightsService.getExpiredTestPeriodData(
          (response: BaseDocumentAccessRightData) =>
            setDocumentAccessData(response),
          () => {}
        );
        break;
      }
      default: {
        break;
      }
    }
  }, [contentType]);

  if (
    documentAccessData &&
    contentType !== DocumentAccessContentType.NotFetched
  ) {
    return (
      <Modal
        ariaHideApp={false}
        isOpen={modalIsOpen}
        className="document-access-modal-styling"
        overlayClassName="document-access-modal-overlay_Textobfuscation"
        shouldCloseOnOverlayClick={true}
        shouldFocusTrap={false}
        shouldReturnFocusAfterClose={false}
        style={{content: { width: width, left: leftLocation}}}
      >
        <div className="document-access-modal">
          <DocumentAccessHeaderArea
            contentType={contentType}
            headerAreaText={documentAccessData.headerArea}
            logInReturnUrl={returnUrl}
            />
          <DocumentAccessMainArea
            contentType={contentType}
            mainAreaText={documentAccessData.mainArea}
            buttonHint={documentAccessData.buttonHint}
            buttonText={documentAccessData.buttonText}
            linkUrl={documentAccessData.linkUrl}
            farOnlinePackageOrAddons={farOnlinePackageOrAddons}
            showOnlyPackages={showOnlyPackages}
            addonCheckoutUrl={addonCheckoutUrl}
            logInReturnUrl={returnUrl}
            />
            {documentAccessData?.taghtml && <div className="tagwrapper" dangerouslySetInnerHTML={{ __html: documentAccessData?.taghtml}}/>}
          <div className="document-access-modal_slice"/>
          <div className="document-access-modal__imagesection">
          </div>
        </div>
      </Modal>
    );
  } else return <BlurredModalOverlay />;
};
